import { render, staticRenderFns } from "./BaseBackground.vue?vue&type=template&id=98e275e8&"
import script from "./BaseBackground.vue?vue&type=script&lang=ts&"
export * from "./BaseBackground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports